import { render, staticRenderFns } from "./HostedWaitingListFormClosedSvg.vue?vue&type=template&id=04c693e7&scoped=true&"
import script from "./HostedWaitingListFormClosedSvg.vue?vue&type=script&lang=js&"
export * from "./HostedWaitingListFormClosedSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c693e7",
  null
  
)

export default component.exports